import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getMenuByRoleId = async (roleId: number) => {
  const url = endpoints.VIEW_LIST_MENU_BY_ROLE(roleId);

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getMenus = async () => {
  const url = endpoints.VIEW_LIST_MENU;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const menu = {
  getMenuByRoleId,
  getMenus,
};

export default menu;
